<template>
  <div class="f-row h-100">
    <div class="col col-12 text-center h-100" style="width:100%;">
      <div class="row f-row">
        <div class="col col-12 chart-title">
          Step 3: Visualize, Compare, and Optimize Strategies
        </div>
      </div>
      <div
        class="row f-row justify-content-center mt-2"
        style="font-size: 0.8rem;"
      >
        <div class="col col-8">
          <div class="row f-row justify-content-center">
            <div class="col col-auto v-align">
              <button class="btn detailView" v-on:click="onShowSims(0)">
                <i
                  class="fa fa-minus"
                  style="color:var(--expo)"
                  v-if="showUnhedged"
                ></i>
                <i
                  class="fa fa-minus"
                  style="color:var(--graylightbackground)"
                  v-else
                ></i>
              </button>
              <span class="mr-2 ml-1">Unhedged</span>
            </div>
            <div class="col col-auto v-align">
              <button class="btn detailView" v-on:click="onShowSims(1)">
                <div
                  v-bind:class="[
                    showHedged ? 'circle-hedge' : 'circle-hedge-off',
                  ]"
                >
                  o
                </div>
              </button>
              <span class="mr-2 ml-1">Client-Designed Portfolio</span>
            </div>
            <div class="col col-auto v-align" v-if="shownStrategy.id > -1">
              <button class="btn detailView" v-on:click="onShowSims(2)">
                <div
                  v-bind:class="[
                    showStrategy ? 'circle-gray' : 'circle-hedge-off',
                  ]"
                >
                  o
                </div>
              </button>
              <span class="mr-2 ml-1">{{ shownStrategy.name }}</span>
            </div>
            <div class="col col-auto ml-3 mr-3 v-align">
              <span class="mr-2">|</span>
            </div>
            <div class="col col-auto">
              <label
                :for="'selectShowAll'"
                class="toggle__button_rt"
                style="height: 100%;"
                :class="{ actives: selectedPositionBoolean }"
              >
                <input
                  type="checkbox"
                  @click="onUserPositionChange"
                  :id="'selectShowAll'"
                  v-model="selectedPositionBoolean"
                />
                <span class="toggle__switch_rt" style="width: 16vw;">
                  <div class="row f-row justify-content-center">
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      All
                    </div>
                    <div
                      class="col col-6 txt-label-primary-2 text-center"
                      style="font-size: 0.75rem!important;"
                    >
                      90% Interval
                    </div>
                  </div>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="col col-3 text-center v-align">
          Client-Designed Portfolio
        </div>
      </div>
      <div
        class="row f-row justify-content-center"
        style="height:calc(100% - 75px)!important;"
      >
        <div
          class="mt-3 h-100 text-center modal-upload-expo"
          style="background: var(--lightbackground-alpha3); vertical-align: middle!important;"
          v-if="!allSimulated"
        >
          <div style="width: 100%; height: calc(50% - 70px)"></div>
          <span v-if="showLoadingSimulating">
            Simulation in Progress
            <QSLoading
              :isLoading="showLoadingSimulating"
              :size="20"
              :colorTheme="colorTheme"
            />
            <br />
          </span>
          <span v-if="valuating">
            Performing Calculations
            <QSLoading
              :isLoading="valuating"
              :size="20"
              :colorTheme="colorTheme"
            />
            <br />
          </span>
          <button
            v-else-if="!allValuated"
            type="button"
            class="btn btn-strat"
            style="width: 75%!important; height: 70px; font-size: 1rem;"
            v-on:click="onUserValuateAll"
          >
            Run All Calculations
          </button>
          <button
            v-show="!showLoadingSimulating"
            type="button"
            class="btn btn-strat"
            style="width: 75%!important; height: 70px; font-size: 1rem;"
            v-on:click="onUserSimulate"
            :disabled="!allValuated"
          >
            {{ allValuated ? "Simulate" : "Simulate (waiting)" }}
          </button>
        </div>
        <div class="col col-8 h-100">
          <SimulationsChart
            :asset="asset"
            :baseCurrency="baseCurrency"
            :chartData="simulationsSliced"
            :colorTheme="colorTheme"
            :minMaxXYAxisSim="minMaxSim"
            :minMaxXYAxisPerc="minMaxSimP"
            :renderChartSignal="renderChartSignal"
            :showLoading="showLoadingSimulating"
            :shownStrategy="shownStrategy"
            :processData="processData"
            :showUnhedged="showUnhedged"
            :showHedged="showHedged"
            :showStrategy="showStrategy"
            :showAllSims="showAllSims"
            @eventOnUserOptimize="onUserOptimize"
          />
        </div>
        <div class="col col-3 h-100" style="overflow: auto">
          <div class="h-100 d-flex flex-column">
            <!-- Row: table -->
            <div
              class="row f-row"
              v-bind:class="{
                pie_chart_1: portfolioComposition.length === 1,
                pie_chart_2: portfolioComposition.length === 2,
                pie_chart_3: portfolioComposition.length === 3,
                pie_chart_4: portfolioComposition.length === 4,
                pie_chart_5: portfolioComposition.length > 5,
              }"
            >
              <div class="col col-12 h-100" style="width:100%;padding: 1px;">
                <SimulationsTable
                  :colorTheme="colorTheme"
                  :showCalculator="showCalculator"
                  :selectedStrategyLegs="selectedStrategyLegs"
                  :portfolioStats="portfolioStats"
                  :portfolioCost="portfolioCost"
                  :portfolioComposition="portfolioComposition"
                  :baseCurrency="baseCurrency"
                  :confidence="confidence"
                  :asset="'currencies'"
                  :notionalTotal="notionalTotal"
                  :showLoadingOptimizing="showLoadingOptimizing"
                  :selectedPosition="selectedPosition"
                  @eventOnUserOptimize="onUserOptimize"
                  @eventOnUserConfidence="onUserConfidence"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-caption d-none d-md-block mb-2 txt-carrousel-bottom">
      Step 3: Specify Hedge Percentages for Each Strategy
    </div>
  </div>
</template>

<script>
import QSLoading from "@/components/QSLoading.vue";
import SimulationsChart from "@/components/optimizer/SimulationsChart";
import SimulationsTable from "@/components/optimizer/SimulationsTable";
import { format } from "d3";

export default {
  name: "StrategiesOptimization",
  components: {
    QSLoading,
    SimulationsChart,
    SimulationsTable,
  },
  props: {
    allSimulated: { required: true, type: Boolean, default: false },
    allValuated: { required: true, type: Boolean, default: false },
    asset: { required: true, default: () => [] },
    baseCurrency: { required: true, default: () => [] },
    colorTheme: { required: true, type: Boolean, default: true },
    confidence: { required: true, default: 90 },
    minMaxSim: { required: true, default: () => [] },
    minMaxSimP: { required: true, default: () => [] },
    notionalTotal: { required: true, default: 0 },
    portfolioComposition: { required: true, default: () => [] },
    portfolioCost: { required: true, default: 0 },
    portfolioStats: {
      required: true,
      default: function() {
        return {
          var: 0,
          ave: 1,
          best: 2,
          varPnl: 3,
          avePnl: 4,
          bestPnl: 5,
          varH: 6,
          aveH: 7,
          bestH: 8,
          varPnlH: 9,
          avePnlH: 10,
          bestPnlH: 11,
        };
      },
    },
    processData: { required: true },
    renderChartSignal: { required: true, default: 0 },
    selectedPosition: { required: true, default: 1 },
    selectedStrategyLegs: { required: true, default: 1 },
    showCalculator: { required: true },
    showHedged: { required: true, type: Boolean, default: true },
    showLoadingOptimizing: { required: true, type: Boolean, default: false },
    showLoadingSimulating: { required: true, type: Boolean, default: false },
    shownStrategy: {
      required: true,
      default: function() {
        return { id: -1, name: null };
      },
    },
    showStrategy: { required: true, type: Boolean, default: true },
    showUnhedged: { required: true, type: Boolean, default: true },
    simulations: { required: true, default: () => [] },
    simulationsSliced: { required: true, default: () => [] },
    valuating: { required: true, type: Boolean, default: false },
  },
  data() {
    return {
      showAllSims: "ALL",
    };
  },
  computed: {
    selectedPositionBoolean: {
      get() {
        return this.showAllSims === "90";
      },
      set() {
        return false;
      },
    },
  },
  filters: {
    percentageFormat: function(val) {
      return format(",.1%")(val);
    },
  },
  methods: {
    onUserSimulate() {
      this.$emit("eventOnUserSimulate");
    },
    onUserValuateAll() {
      this.$emit("eventOnUserValuateAll");
    },
    onShowSims(val) {
      this.$emit("eventOnShowSims", val);
    },
    onUserPositionChange() {
      this.showAllSims = this.showAllSims === "ALL" ? "90" : "ALL";
    },
    onUserConfidence(val) {
      this.$emit("eventOnUserConfidence", val);
    },
    onUserOptimize(arg) {
      this.$emit("eventOnUserOptimize", arg);
    },
  },
};
</script>

<style scoped>
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "ALL";
  font-size: 0.75rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "90% INTERVAL";
}
</style>
